<template>
  <div
    :class="{ eligible: isEligible, certified: !isEligible, selected: isSelected }"
    class="board-certification-item p-1 pl-2"
    @click="onClick"
  >
    {{ certification.title }}
  </div>
</template>

<script>
export default {
  name: 'UserProfileBoardCertificationItem',
  props: {
    certification: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      isSelected: false,
    };
  },
  computed: {
    isEligible: function () {
      return !parseInt(this.certification.is_certified);
    },
  },
  methods: {
    onClick: function () {
      this.isSelected = !this.isSelected;
      this.$emit('itemSelected', {
        id: this.certification.id,
        isSelected: this.isSelected,
      });
    },
  },
};
</script>

<style scoped/>
